module.exports = __webpack_public_path__ + "79515ad0788973c533405f7012dfeccd.woff";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-regular.woff
// module id = 1542
// module chunks = 0